
<div class="card treemap-card" [style.--treemap-target-height]="treemapTargetHeight">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column align-items-center">
      <h4 >{{ data.title | capitalCase }}</h4>
    </div>
  </div>

  <div class="legend-wrapper" *ngIf="!hasError && legendItems.length > 0">
    
    <button 
      *ngIf="showLeftArrow" 
      (click)="scrollLegend('left')" 
      class="scroll-arrow left">
      <
    </button>

    <div 
      #legendContainer 
      class="custom-legend-container" 
      (scroll)="updateArrowVisibility()">
      <div
        *ngFor="let item of legendItems"
        class="legend-item"
        [class.active]="activeLegend === item.name"
        [class.dimmed]="activeLegend !== null && activeLegend !== item.name"
        (click)="toggleLegend(item.name)"
        style="cursor: pointer;">
        <span class="legend-color-box" [style.background-color]="item.color"></span>
        <span class="legend-label">{{ item.name }}</span>
      </div>
    </div>

    <button 
      *ngIf="showRightArrow" 
      (click)="scrollLegend('right')" 
      class="scroll-arrow right">
      >
    </button>

  </div>

  <div class="card-body treemap-body">
    <div [class.hidden]="hasError" class="treemap-chart-shell" [class.with-legend]="!hasError && legendItems.length > 0">
      <div [id]="widgetId" class="treemap-chart"></div>
    </div>
  </div>
  
<ng-template [ngIf]="hasError">
  <app-data-error [message]="errorMessage" />
</ng-template>

</div>
